import { useOpQuery } from './useOpQuery';
import { useIdentityAndUser } from './useIdentityAndUser';

/**
 * Hook to check if the current user needs to set up MFA. (Includes all orgs)
 * Returns the loading state and whether MFA setup is required.
 */
export const useMfaSetupStatus = () => {
  const { token, identityId, isLoading: isLoadingToken } = useIdentityAndUser();

  const { data: mfaCredentials, isLoading: isLoadingMfaCredentials } =
    useOpQuery({
      apiEndpointName: 'listMfaCredentials',
      parameters: [Number(identityId)],
      select: (response) => response.json.data,
      // Only run query when identityId is available
      enabled: Boolean(identityId),
    });

  // Check if ANY scope across ALL orgs requires MFA
  // This uses the token's scopeWithContext which has MFA requirement info
  const requiresMfa = token?.tokenScopeList?.some((tokenScope) =>
    tokenScope.scopeWithContext?.some((scope) =>
      scope.context?.some((context) => context.mfa),
    ),
  );

  const isLoading = isLoadingToken || isLoadingMfaCredentials;

  const needsMfaSetup = requiresMfa && mfaCredentials?.length === 0;

  return {
    needsMfaSetup,
    isLoading,
    mfaCredentials,
  };
};
